import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classes", "overrides", "className", "content", "placement"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import RCTooltip from 'rc-tooltip';
import { getOverrides, useClasses } from '../../../utils/overrides';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
var useStyles = createUseStyles(styles, 'Tooltip');
function Tooltip(_ref) {
  var children = _ref.children,
    classesProp = _ref.classes,
    overridesProp = _ref.overrides,
    classNameProp = _ref.className,
    content = _ref.content,
    placement = _ref.placement,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(useStyles, classesProp);
  // Overrides
  var override = getOverrides(overridesProp, Tooltip.overrides);

  // Classes
  var rootClassName = classnames(classes.root, classNameProp);
  var rootProps = _objectSpread(_objectSpread({}, props), {}, {
    prefixCls: 'hoi-poi-tooltip',
    transitionName: 'hoi-poi-tooltip--fade',
    trigger: ['hover'],
    overlayClassName: rootClassName,
    overlay: content,
    placement: placement
  });
  if (content === undefined || content === null) return children;
  return /*#__PURE__*/React.createElement(RCTooltip, _extends({}, rootProps, override.root), children);
}
Tooltip.overrides = ['root'];
Tooltip.defaultProps = {
  overrides: {},
  placement: 'top'
};
process.env.NODE_ENV !== "production" ? Tooltip.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  content: PropTypes.any,
  placement: PropTypes.oneOf(['top', 'topLeft', 'topRight', 'bottom', 'bottomLeft', 'bottomRight', 'left', 'leftTop', 'leftBottom', 'right', 'rightTop', 'rightBottom'])
} : void 0;
export default /*#__PURE__*/React.memo(Tooltip);